import { CheckCircle2, Download } from "lucide-react";
import { API_BASE } from "@/lib/api";

export default function SignupSuccess({ email }) {
  return (
    <div className="text-center py-6" data-testid="signup-success">
      <div className="inline-flex items-center justify-center h-14 w-14 rounded-full bg-primary/10 text-primary mb-4">
        <CheckCircle2 className="h-7 w-7" />
      </div>
      <h3 className="font-display text-3xl text-foreground">Welcome aboard.</h3>
      <p className="mt-3 font-body text-foreground/80">
        The book is on its way to <strong className="text-secondary">{email}</strong>.
        Don&apos;t see it? Check spam — and add Professor KnowOne to your contacts.
      </p>
      <a
        href={`${API_BASE}/book/pdf`}
        target="_blank"
        rel="noreferrer"
        data-testid="signup-download-now"
        className="mt-6 inline-flex items-center gap-2 px-5 py-3 rounded-full bg-secondary text-secondary-foreground hover:bg-secondary/90 font-ui text-sm transition-colors"
      >
        <Download className="h-4 w-4" /> Or grab it directly
      </a>
    </div>
  );
}
